export default __webpack_public_path__ + "static/media/HPAS.af5ec35d.png";